import { useQuery } from 'react-query'
import { useLocation } from 'react-router-dom'
import apiService from '../services/api'
import { apiURL } from '../services/api/apiURL'

export const useUsers = (role = 'brand', search = '', campaignId) => {
  let { search: searchQuery } = useLocation()
  const defaultSearch = `?perPage=10&page=1&search=${search}`

  if (searchQuery === undefined || searchQuery === '') {
    searchQuery = defaultSearch
  }

  const fetchBrands = () => {
    const uri = `${apiURL.users.get(role)}${searchQuery}${
      campaignId ? `&campaignId=${campaignId}` : ''
    }`
    return apiService.get(uri)
  }

  const { data, ...rest } = useQuery(
    [role, searchQuery ?? defaultSearch, search, campaignId ?? ''],
    fetchBrands
  )

  return {
    data: data?.data.data,
    pagination: data?.data.pagination,
    ...rest
  }
}
